import React from "react";
import { Banner, BannerTitle, BannerSubtitle } from "./styles";
import { DuplicateBannerProps } from "./types";

export const DuplicateBanner: React.FC<DuplicateBannerProps> = ({
  originalDate,
}) => {
  const title = originalDate
    ? `Copied from ${originalDate}`
    : "Copied transaction";

  return (
    <Banner>
      <BannerTitle>{title}</BannerTitle>
      <BannerSubtitle>
        Date updated to today. Tweak any field before creating.
      </BannerSubtitle>
    </Banner>
  );
};
